var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sdk-universal-config-manage-page" },
    [
      _c(
        "basic-container",
        [
          _c(
            "div",
            { staticClass: "search-form-wrap" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { size: "small", inline: true, model: _vm.formInline },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "参数项" },
                          model: {
                            value: _vm.formInline.ptype,
                            callback: function ($$v) {
                              _vm.$set(_vm.formInline, "ptype", $$v)
                            },
                            expression: "formInline.ptype",
                          },
                        },
                        _vm._l(_vm.sdkCategoryOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "配置名称/KEY" },
                        model: {
                          value: _vm.formInline.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.formInline, "search", $$v)
                          },
                          expression: "formInline.search",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_SEARCH",
                              expression:
                                "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_SEARCH'",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_ADD",
                              expression:
                                "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_ADD'",
                            },
                          ],
                          attrs: { type: "primary", plain: "" },
                          on: { click: _vm.openDialog },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL",
                              expression:
                                "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'",
                            },
                          ],
                          attrs: { type: "danger", plain: "" },
                          on: { click: _vm.handleDelete },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              option: _vm.option,
              page: _vm.page,
              "table-loading": _vm.loading,
              data: _vm.data,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "selection-change": _vm.handleSelectionChange,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_EDIT",
                            expression:
                              "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_EDIT'",
                          },
                        ],
                        attrs: {
                          size: "small",
                          type: "text",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL",
                            expression: "'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'",
                          },
                        ],
                        attrs: {
                          size: "small",
                          type: "text",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDeleteRow(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEdit ? "编辑" : "新增",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.visible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.onDialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content-wrap" },
            [
              _c(
                "el-form",
                {
                  ref: "editForm",
                  attrs: {
                    model: _vm.formModel,
                    rules: _vm.rules,
                    size: "small",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "配置分类", prop: "ptype" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择参数项配置" },
                          model: {
                            value: _vm.formModel.ptype,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModel, "ptype", $$v)
                            },
                            expression: "formModel.ptype",
                          },
                        },
                        _vm._l(_vm.sdkCategoryOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "参数项名称", prop: "pname" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formModel.pname,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "pname", $$v)
                          },
                          expression: "formModel.pname",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "参数项ID", prop: "pkey" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formModel.pkey,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "pkey", $$v)
                          },
                          expression: "formModel.pkey",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "默认值", prop: "pdefault" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formModel.pdefault,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "pdefault", $$v)
                          },
                          expression: "formModel.pdefault",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "参数值", prop: "pvalue" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 4 },
                        model: {
                          value: _vm.formModel.pvalue,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModel, "pvalue", $$v)
                          },
                          expression: "formModel.pvalue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("LogDialog", { ref: "logDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }